import logoEmployer from '@pe-libs/react-components/build/assets/common/logos/logo-icon-employer.svg';
import logo from '@pe-libs/react-components/build/assets/common/logos/logo-icon.svg';
import PeImage from '@pe-libs/react-components/build/components/PeImage';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC } from 'react';
import useRedirect from '#hooks/useRedirect';
import messages from './messages';
import useStyles from './styles';

const Logo: FC<{ isProvenEmployer?: boolean }> = ({ isProvenEmployer }) => {
  const formatMessage = useIntlMessage();
  const styles = useStyles();
  const { urlToLivePage } = useRedirect();

  return (
    <PeLink
      href={urlToLivePage('home', isProvenEmployer)}
      title={formatMessage(isProvenEmployer ? messages.logoTitleEmployer : messages.logoTitle)}
      className={isProvenEmployer ? styles.logoEmployer : styles.logo}
    >
      {isProvenEmployer ? (
        <PeImage
          width={24}
          height={24}
          layout="fixed"
          alt={formatMessage(messages.logoTitleEmployer)}
          src={logoEmployer as string}
        />
      ) : (
        <PeImage width={48} height={48} layout="fixed" alt={formatMessage(messages.logoTitle)} src={logo as string} />
      )}
    </PeLink>
  );
};

export default Logo;
